import { TextFieldController } from '@components/react-hook-components'
import type { Control, FieldValues, Path } from 'react-hook-form'

type IntegerFeatureValueInputProps<T extends FieldValues> = {
  control: Control<T>
  name: Path<T>
}

export const IntegerFeatureValueInput = <T extends FieldValues>({ control, name }: IntegerFeatureValueInputProps<T>) => {
  return <TextFieldController control={control} name={name} labelText="Value (optional)" type="number" />
}
